module.exports = __webpack_public_path__ + "static/media/CloudMoon04n.b82cfcb9.png";